import { vaultGetRequest } from '../helpers';
import type { IVaultRootResponse } from './fetch-root-response';
import { vaultRootResponseSchema } from './fetch-root-response';

export async function fetchRootApi(): Promise<IVaultRootResponse> {
  return vaultGetRequest({ path: '/', schema: vaultRootResponseSchema });
}
